var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"draw-circle"},[_c('canvas',{attrs:{"id":_vm.myCanvas,"width":"72","height":"72"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }